import { types } from './dmoImporterActions';

const initialState = {
    pending: false,
    payload: {},
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.HTTP_PENDING_DMO_IMPORTER:
            return {
                ...state,
                pending: true
            }
        case types.HTTP_SUCCESS_DMO_IMPORTER:
            return {
                ...state,
                pending: false,
                payload: action.payload
            }

        case types.HTTP_ERROR_DMO_IMPORTER:
            return {
                ...state,
                pending: false,
                error: action.error,
            }
        default:
            return state;
    }
}

